const HUB_PATH = '/hub'

function stripThemeQueryQuotes(value: string): string {
  const trimmed = value.trim()

  if (
    (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
    (trimmed.startsWith("'") && trimmed.endsWith("'"))
  ) {
    return trimmed.slice(1, -1).trim()
  }

  return trimmed
}

export function readThemeQueryValueFromSearch(search: string): string | null {
  const params = new URLSearchParams(search || '')
  const themeValue = String(params.get('theme') || '').trim()
  return themeValue || null
}

export function readThemeQueryValueFromPathname(
  pathname: string,
): string | null {
  const match = String(pathname || '').match(/^\/p\/([^/?#]+)/)
  if (!match?.[1]) return null

  try {
    return decodeURIComponent(match[1]).trim() || null
  } catch {
    return match[1].trim() || null
  }
}

export function normalizeThemeQueryId(value: unknown): string {
  return stripThemeQueryQuotes(String(value || ''))
    .trim()
    .toLowerCase()
}

export function normalizeThemeQueryLookup(value: unknown): string {
  return normalizeThemeQueryId(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
}

export function normalizeThemeQueryFallbackId(value: unknown): string {
  return stripThemeQueryQuotes(String(value || ''))
    .trim()
    .replace(
      /\u00e2\u20ac\u201d|\u00e2\u20ac\u201c|\u00e2\u20ac\u2013|\u2014|\u2013/g,
      ' ',
    )
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['\u2019"]/g, ' ')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function buildHubLocationWithThemeSearch(search: string) {
  return {
    pathname: HUB_PATH,
    search: readThemeQueryValueFromSearch(search) ? search : '',
  }
}
